import { IImageZoomDTO } from 'business/models/Models';
import EScoringGroup from 'enums/EScoringGroup';
import ETreeNodeAccessRightNames from 'enums/ETreeNodeAccessRightNames';
import { RootState } from 'redux/configureStore';
import { isNullOrUndefined } from 'utils/Global';

export function selectSelectedCell(state: RootState) {
  return isNullOrUndefined(state.plate) ? undefined : state.plate.selectedCell;
}
export function selectInspectionSetID(state: RootState) {
  return state.experiment?.wellSelectionDetails?.selectedDropImageParameters?.inspection
    ?.id;
}

export function selectInspectionSet(state: RootState) {
  return state.experiment?.wellSelectionDetails?.selectedDropImageParameters?.inspection;
}

export function selectScoreGroup(state: RootState) {
  return !isNullOrUndefined(state.headers.scoreGroup)
    ? state.headers.scoreGroup
    : EScoringGroup.All;
}

export function selectAutoSelectNextWell(state: RootState) {
  return state.headers.autoSelectNextWell != null ||
    state.headers.autoSelectNextWell != undefined
    ? state.headers.autoSelectNextWell
    : false;
}

export function selectCurrentWellScores(state: RootState) {
  return state.experiment === undefined ||
    state.experiment === null ||
    state.experiment.currentWellScores === undefined
    ? undefined
    : state.experiment.currentWellScores;
}

export function selectLowerLevelLimit(state: RootState) {
  return state.plate === undefined ||
    state.plate === null ||
    state.plate.imageTuningValues === undefined
    ? undefined
    : state.plate.imageTuningValues.lowerLevelLimit;
}

export function selectUpperLevelLimit(state: RootState) {
  return state.plate === undefined ||
    state.plate === null ||
    state.plate.imageTuningValues === undefined
    ? undefined
    : state.plate.imageTuningValues.upperLevelLimit;
}

export function selectAutoLevelingLowThreshold(state: RootState) {
  return state.plate === undefined ||
    state.plate === null ||
    state.plate.imageTuningValues === undefined
    ? undefined
    : state.plate.imageTuningValues.autoLevelingLowThreshold;
}

export function selectImageTuningValues(state: RootState) {
  return state.plate === undefined ||
    state.plate === null ||
    state.plate.imageTuningValues === undefined
    ? undefined
    : state.plate.imageTuningValues;
}
export function selectAutoLevelingHighThreshold(state: RootState) {
  return state.plate === undefined ||
    state.plate === null ||
    state.plate.imageTuningValues === undefined
    ? undefined
    : state.plate.imageTuningValues.autoLevelingHighThreshold;
}

export function selectAutoLevelingModeOn(state: RootState) {
  return state.plate === undefined ||
    state.plate === null ||
    state.plate.imageTuningValues === undefined
    ? undefined
    : state.plate.imageTuningValues.isAutoLevelingOn;
}

export function selectAutoLevelLowerLimit(state: RootState) {
  return state.plate === undefined ||
    state.plate === null ||
    state.plate === undefined ||
    state.experiment.wellSelectionDetails === undefined ||
    state.plate.imageTuningValues === undefined
    ? undefined
    : state.plate.imageTuningValues.autoLevelingLowerLimit;
}

export function selectAutoLevelUpperLimit(state: RootState) {
  return state.plate === undefined ||
    state.plate === null ||
    state.plate.imageTuningValues === undefined
    ? undefined
    : state.plate.imageTuningValues.autoLevelingUpperLimit;
}

export function selectGlobalDataLoaded(state: RootState) {
  return state === undefined || state.plate === undefined
    ? false
    : state.plate.globaldataloaded;
}

export function selectHideAutoScores(state: RootState) {
  return state.headers === undefined || state.headers === null
    ? undefined
    : state.headers.hideAutoScores;
}

export function selectScoringWell(state: RootState) {
  return state.experiment === undefined ||
    state.experiment === null ||
    state.experiment.scoringWell === undefined
    ? undefined
    : state.experiment.scoringWell;
}

export function selectCells(state: RootState) {
  return state.plate === undefined ? undefined : state.plate.cells;
}

export function selectWellInfo(state: RootState, selectedcell) {
  return state.plate === undefined ||
    selectedcell === undefined ||
    selectedcell.currentPlate === undefined ||
    state.plate === null
    ? undefined
    : state.plate.wellInfo[selectedcell.currentPlate][selectedcell.currentWell];
}

export function selectShowProgress(state: RootState) {
  return state.notification?.showProgress;
}

export function selectProgress(state: RootState) {
  return state.notification?.progress;
}

export function selectProgressMessage(state: RootState) {
  return state.notification?.message;
}

export function selectProgressStatus(state: RootState) {
  return state.notification?.progressStatus;
}

export function selectCurrentPlate(state: RootState) {
  return state.plate === undefined ||
    state.plate === null ||
    isNullOrUndefined(state.plate.selectedCell)
    ? 0
    : state.plate.selectedCell.currentPlate;
}

export function isGenerateRequired(state: RootState) {
  return isNullOrUndefined(state.plate) ? 0 : state.plate.generateReqd;
}

export function selectedExpDataUpdated(state: RootState) {
  return state.plate.expData;
}

export function selectLinkedLayers(state: RootState) {
  return state.layer.linkedLayer;
}

export function selectDeletedLayers(state: RootState) {
  return state.layer.deletedLayers;
}
export function selectDeleteFamily(state: RootState) {
  return state.layer.deleteFamily;
}

export function selectPresnetSate(state: RootState) {
  return state.experiment.expData;
}

export function selectedDrawingState(state: RootState) {
  return state.plate.selectedDrawing;
}

export function selectedSystemTasksState(state: RootState) {
  return state.systemTasks.tasks;
}

export function selectIsDispensed(state: RootState) {
  if (isNullOrUndefined(state.experiment.expData)) {
    return false;
  }
  return state.experiment.expData.isDispensed;
}

export function selectIsEditable(state: RootState) {
  if (isNullOrUndefined(state.plate.isEditableActive)) {
    return false;
  }
  return state.plate.isEditableActive;
}
export function selectIsModifyAccessRights(state: RootState) {
  if (isNullOrUndefined(state.experiment.expData)) {
    return true;
  }
  return state.experiment.expData.accessRightName === ETreeNodeAccessRightNames.Modify;
}

export function selectHitWells(state: RootState) {
  return state.plate.expHitWells;
}

export function selectHitButtonName(state: RootState) {
  return state.plate.hitButtonName;
}
export function selectExpSaved(state: RootState) {
  return state.plate.expSaved;
}
export function selectAnnotations(state: RootState, dropNumber: number) {
  return state.plate.annotations && state.plate.annotations[dropNumber];
}
export function selectRulers(state: RootState, dropNumber: number) {
  return state.plate.rulers && state.plate.rulers[dropNumber];
}
export function selectScribbles(state: RootState, dropNumber: number) {
  return state.plate.scribbles && state.plate.scribbles[dropNumber];
}
export function selectIsMoveToCompareTab(state: RootState) {
  return state.plate.isMoveToCompareTab;
}
export function selectROIs(state: RootState, dropNumber: number) {
  return state.plate.rois && state.plate.rois[dropNumber];
}
export function selectPOIs(state: RootState, dropNumber: number) {
  return state.plate.pois && state.plate.pois[dropNumber];
}
export function selectCrystals(state: RootState, dropNumber: number) {
  return state.plate.crystals && state.plate.crystals[dropNumber];
}
export function selectProductEdition(state: RootState) {
  return state.plate.product.edition;
}
export function selectIsWellImagingEnabled(state: RootState) {
  return state.plate.isWellImagingEnabled;
}
export function selectRegionImaging(state: RootState) {
  return state.plate.isRegionImaging;
}
export function selectDrawingColor(state: RootState) {
  return state.plate.drawingColor;
}
export function selectPlatesAtImagerStatus(state: RootState) {
  return state.experiment.platesAtImagerStatus;
}
export function selectWellDropRegions(state: RootState) {
  return state.plate.wellDropRegions;
}
export function selectPlateDrawings(state: RootState) {
  return state.plate.plateDrawings;
}

export function selectedIngredientList(state: RootState) {
  return state.plate.selectedIngredients;
}

export function selectSelectedIngredientsRows(state: RootState) {
  return state.ingredientsTable.selectedRows;
}

export function selectCheckedCrystals(state: RootState) {
  return state.plate.checkedCrystalIDs;
}

export function selectCrystalId(state: RootState) {
  return state.synchrotronTrip.crystalId;
}

export function selectTripResultIDs(state: RootState) {
  return state.synchrotronTrip.selectedTripResultIDs;
}

export function selectSelectedAssignedCrystalIds(state: RootState) {
  return state.synchrotronTrip.selectedAssignedCrystalIds;
}

export function selectImportFl(
  state: RootState,
  plateId: number,
  wellNumber: number,
  dropNumber: number,
) {
  const plate = state.experiment?.expData?.plateDto?.find((p) => p.plateId === plateId);
  if (!plate) {
    return null;
  }

  const well = plate.ingredients?.wellList?.find((w) => w.wellNumber === wellNumber);
  if (!well) {
    return null;
  }

  const wellDrop = well.dropList?.find((d) => d.dropNumber === dropNumber);
  if (!wellDrop) {
    return null;
  }

  return wellDrop.importFl;
}

export const selectNavigatorAvailableImagesKeys = (state: RootState) => {
  return state.plate.navigatorImagesAvailableKeys;
};

export const selectImageZoomVisibleArea = (state: RootState): IImageZoomDTO => {
  return state.well.imageZoomDto;
};
